export const REQUEST_CATEGORY_PARENT_LIST = "REQUEST_CATEGORY_PARENT_LIST"
export const REQUEST_CATEGORY_LIST = "REQUEST_CATEGORY_LIST"
export const REQUEST_CATEGORY_LIST_FOR_CREATE = "REQUEST_CATEGORY_LIST_FOR_CREATE"